import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

// ✅ Reusable thunk for TRUE GET endpoints (no request body), e.g. GetMfaStatus.
// postData/getData always POST a FormData body — that breaks any endpoint
// that is registered as GET-only on the backend. Use this one instead for
// those cases. Pass `params` (plain object) if the endpoint needs query
// params, e.g. getRequest({ url: "SomeController/GetById", params: { Id: 5 } })
// -> SomeController/GetById?Id=5
export const getRequest = createAsyncThunk(
  "getRequest/fetch",
  async ({ url, params }) => {
    try {
      const response = await axiosInstance.get(url, {
        headers: {
          Accept: "*/*",
        },
        params: params || {},
      });
      return response && response.data;
    } catch (error) {
      console.error("Error in getRequest:", error);
      throw error;
    }
  },
);

const getRequestSlice = createSlice({
  name: "getRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRequest.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getRequest.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getRequest.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default getRequestSlice.reducer;